import axios from 'axios';
import { useQuery } from 'react-query';

import { OwnerRankings } from '~/../api/common.types';

export const useGetOwnedNFTs = ({ address }) => {
  return useQuery<OwnerRankings[], Error>(
    ['ownedNFTs', address],
    async () => {
      const { data: ownedWarriorIDs } = await axios({
        url: `/api/rankings/totalOwned?address=${address}`,
        method: 'get',
      });
      return ownedWarriorIDs.data;
    },
    {
      enabled: !!address,
    }
  );
};
